import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=5453a126&"
import script from "./HeaderBar.vue?vue&type=script&lang=ts&"
export * from "./HeaderBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports